import { useLayoutEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { bindClerkGetToken } from '../../services/clerkApiAuth';

export default function ClerkApiAuthBinder() {
  const { getToken } = useAuth();

  useLayoutEffect(() => {
    bindClerkGetToken(getToken);
    return () => bindClerkGetToken(null);
  }, [getToken]);

  return null;
}
